import { DashboardViewFragment } from 'generated/graphql';
import { getSavedSlug } from 'v2/core/services/savedSlug/utils';
import pathJoin from 'v2/core/utils/path';
import { NAV_PATHS } from '@modules/common/constants';

export const getDashboardRoute = (
  dashboard: Pick<DashboardViewFragment, 'viewToken' | 'title'>,
): string => {
  return `/${pathJoin(
    NAV_PATHS.DASHBOARD,
    getSavedSlug({
      token: dashboard.viewToken,
      name: dashboard.title,
    }),
  )}`;
};
